<template>
    <section class="card industry-sectors-section">
        <div class="section-header">
            <h3>{{ $trans("web_profile.industry_sectors") }}</h3>
            <EditButton :onClick="WebProfileStore.openEditIndustrySectorsModal" />
        </div>

        <div class="sectors-grid">
            <template
                v-for="sector in WebProfileStore.industrySectors"
                :key="sector.id"
            >
                <div class="profile-card-sector-item">
                    <div class="title">
                        {{ sector.name }} /
                        <span class="title-duration">{{ sector.duration }}</span>
                    </div>
                    <ProfileProgressBar
                        :percentage="sector.duration_percentage"
                        :main-filters="mainFilters"
                        :tag-id="sector.id"
                    />
                </div>
            </template>
        </div>

        <EditIndustrySectorsModal />
    </section>
</template>

<script>
import { mapStores } from "pinia";
import { useWebProfileStore } from "@/stores/WebProfileStore";
import EditIndustrySectorsModal from "./Modals/EditIndustrySectorsModal.vue";
import ProfileProgressBar from "./../Components/ProgressBar.vue";
import EditButton from "./../Components/EditButton.vue";

export default {
    name: "IndustrySectorsSection",
    components: {
        EditIndustrySectorsModal,
        ProfileProgressBar,
        EditButton,
    },
    props: {
        mainFilters: {
            type: Object,
            default: () => ({}),
        },
    },
    computed: {
        ...mapStores(useWebProfileStore),
    },
};
</script>

<style scoped>
.industry-sectors-section {
    padding: 20px;
    background-color: #fff;
    border: 1px solid #ddd;
    border-radius: 8px;
}

.section-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
}

h3 {
    margin: 0;
    font-size: 1.875rem;
    font-weight: 600;
}

.sectors-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 16px;
}

.title {
    font-weight: 700;
    color: #000;
    margin-bottom: 8px;
    font-size: 16px;
}

.el-button {
    background-color: #41abc4;
    border-color: #41abc4;
}
</style>